"use client";

import { getImageUrl } from "@/libs/CloudFlare";
import Image from "next/image";
import Link from "next/link";

interface IProps {
  region: {
    region: string | null;
    id: string;
    city: string | null;
    country: string | null;
    continent: string | null;
    preferCountry: string | null;
  } | null;
  id: string;
  createAt: Date;
  updateAt: Date;
  trafic: number | null;
  translations: {
    id: string;
  }[];
  banners: {
    id: string;
    cloudFlareFileId: string;
    travelGuideId: string;
  }[];
}

function DestinationCard(props: IProps) {
  return (
    <Link
      href={"/news/country/" + props.translations[0]?.id}
      className="relative"
    >
      {props.banners[0]?.cloudFlareFileId ? (
        <Image
          src={getImageUrl(props.banners[0]?.cloudFlareFileId)}
          alt={props.region?.country ?? ""}
          width={352}
          height={240}
          className=" object-cover w-full aspect-[1/0.68] rounded-[28px]"
        />
      ) : (
        <div className="!w-full aspect-[1/0.68] bg-[#D9D9D9] rounded-[28px]" />
      )}

      <div
        className="absolute top-0 bottom-0 left-0 right-0 flex z-20
          w-full h-full items-center justify-center bg-white/50 hover:!bg-none
          transition delay-100 duration-300 ease-in-out hover:opacity-25"
      >
        <p className="h4 text-black">
          <span>{props.region?.country}</span>
        </p>
      </div>
    </Link>
  );
}

export default DestinationCard;
